import TextField from '@mui/material/TextField';

export const TextInput = ({value, label, onChange, placeholder, error, required = true}) => (
    <TextField
        size="small"
        fullWidth
        value={value}
        error={error}
        placeholder={placeholder}
        type="text"
        label={label}
        onChange={({target}) => onChange(target.value)}
        required={required}
        sx={{mb: 1, mt: 1}}
    />
);
